import type { FC } from 'react';
import { Switch } from 'antd';
import type { SwitchProps } from 'antd';

export type IpcSwitchSize = 'small' | 'default';

type Props = Omit<SwitchProps, 'size'> & {
  size?: IpcSwitchSize;
  /** 轨道内显示「开启 / 关闭」文案（对齐业务常用形态） */
  withText?: boolean;
};

/** Showcase §2 Switch：antd Switch + Token；可选内嵌开启/关闭文案 */
export const IpcSwitch: FC<Props> = ({
  size = 'default',
  withText = false,
  checkedChildren,
  unCheckedChildren,
  className,
  ...rest
}) => {
  const onText = checkedChildren ?? (withText ? '开启' : undefined);
  const offText = unCheckedChildren ?? (withText ? '关闭' : undefined);

  return (
    <Switch
      {...rest}
      size={size === 'small' ? 'small' : undefined}
      checkedChildren={onText}
      unCheckedChildren={offText}
      className={['ipc-switch', withText || onText || offText ? 'ipc-switch--with-text' : '', className]
        .filter(Boolean)
        .join(' ')}
    />
  );
};
